import React, { useEffect, useState } from "react";
import DraggableModal from "../../../generic/DraggableModal";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import StyledButton from "../../../generic/StyledButton";
import InputAdornment from "@mui/material/InputAdornment";
import { backendPatchWithoutRefresh } from "../../../../helpers/callBackend";
import SelectBankAccountTag from "../../customTags/selectBankAccountTag";
import checkFlag from "../../../../helpers/featureFlags"; 

const TeamPermissionModal = ({
  currentUserCompanyPermissions,
  setUserCompanyPermissions,
  modalVisible,
  setModalVisible,
  ucsId,
  groups,
  customTags,
  loading,
}) => {
  const [userPermissions, setUserPermissions] = useState([]);
  const [initialPermissions, setInitialPermissions] = useState([]);

  const [userDisplayName, setUserDisplayName] = useState("Unknown User");

  const [visble, setVisible] = useState(false);

  const [userName, setUserName] = useState({
    firstName: "",
    lastName: "",
  });
  
  const [accountAccessTags, setAccountAccessTags] = useState([])
  const [userAccountTags, setUserAccountTags] = useState([])

  const handleAccessChange = (event) => {
    setAccountAccessTags([...event])
  }

  const toggleUnlimited = (event, fieldName) => {
    const initialPermission = initialPermissions.find(
      (permission) => permission.fieldName == fieldName
    );
    const fieldIndex = userPermissions.findIndex(
      (permission) => permission.fieldName == fieldName
    );
    let newValue = "";
    if (event.target.checked) {
      newValue = "-1.00";
    } else {
      newValue =
        initialPermission?.value == "-1.00" ? 0 : initialPermission?.value;
    }

    let newPermissions = [...userPermissions];

    newPermissions[fieldIndex].value = newValue;

    setUserPermissions(newPermissions);
  };

  const handleNameChange = (event, name) => {
    let newUserName = { ...userName };
    newUserName[name] = event.target.value;
    setUserName(newUserName);
  };

  const handleInput = (event, fieldName) => {
    const fieldIndex = userPermissions.findIndex(
      (permission) => permission.fieldName == fieldName
    );
    let newPermissions = [...userPermissions];

    let newValue = event.target.value;

    // unlimited can only be set using toggle. user cannot just enter -1 as input
    if (newValue < 0) {
      newValue = 0;
    }

    newPermissions[fieldIndex].value = newValue;

    setUserPermissions(newPermissions);
  };

  const handleSubmit = async () => {
    let data = {
      id: ucsId,
      settings: {
        first_name: userName.firstName,
        last_name: userName.lastName,
        account_access_tags: accountAccessTags,
      },
    };

    userPermissions.forEach((permission) => {
      data.settings[permission?.fieldName] = permission?.value;
    });

    const patchedUcsObject = await backendPatchWithoutRefresh(
      "/api/landlord/permissions/",
      data
    );

    if (patchedUcsObject.status == 200) {
      let newUcsObjects = [...currentUserCompanyPermissions];
      const patchedIdx = newUcsObjects.findIndex(
        (ucsObject) => ucsObject.id == ucsId
      );
      newUcsObjects.splice(patchedIdx, 1, patchedUcsObject.data.data);
      setUserCompanyPermissions(newUcsObjects);
      setModalVisible(false);
    }
  };

  useEffect(() => {
    const ucsObject = currentUserCompanyPermissions.find(
      (ucsObj) => ucsObj.id == ucsId
    );
    if (!ucsObject) {
      return;
    }
    let newUserName = { ...userName };
    setUserName({
      firstName: ucsObject.first_name,
      lastName: ucsObject.last_name,
    })
    if (ucsObject.first_name || ucsObject.last_name) {
      setUserDisplayName(`${ucsObject.first_name} ${ucsObject.last_name}`);
      newUserName.firstName = ucsObject.first_name;
      newUserName.lastName = ucsObject.last_name;
    } else {
      setUserDisplayName(ucsObject.email);
    }

    const permissions = [
      {
        fieldName: "transaction_creation_limit",
        value: ucsObject.transaction_creation_limit,
        displayName: "Transaction Creation Limit",
      },
      {
        fieldName: "transaction_approve_limit",
        value: ucsObject.transaction_approve_limit,
        displayName: "Transaction Approve Limit",
      },
      {
        fieldName: "transaction_self_approve_limit",
        value: ucsObject.transaction_self_approve_limit,
        displayName: "Transaction Self-Approve Limit",
      },
    ];

    setUserPermissions(permissions);

    if (!initialPermissions.length) {
      setInitialPermissions(permissions);
    }
   
    if (ucsObject?.limited_access_account_tags) {
      const ucsAccessTags = ucsObject.limited_access_account_tags.map((tag) => {
        if (tag.id) {
          // not quick_get-ed 
          return tag
        }
        // quick_get-ed
        return {id: tag}
      })
      setUserAccountTags(ucsAccessTags)
    }

    setVisible(modalVisible);
  }, [currentUserCompanyPermissions, ucsId, modalVisible]);

  return visble ? (
    <DraggableModal
      width="60%"
      modalVisible={modalVisible}
      handleCancelModal={setModalVisible}
      modalTitle={`Edit User Settings for ${userDisplayName}`}
      content={
        <Box display="flex" flexDirection="column" alignItems="center">
          <Grid container spacing={2}>
            <Grid item xs={3} display="flex" alignItems="center">
              <Typography>First Name</Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                placeholder="First Name"
                fullWidth
                value={userName.firstName}
                onChange={(event) => handleNameChange(event, "firstName")}
                size='small'
                InputProps={{
                  style: {
                    borderRadius: 0,
                  },
                }}
              />
            </Grid>
            <Grid item xs={3} display="flex" alignItems="center">
              <Typography>Last Name</Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                placeholder="Last Name"
                fullWidth
                value={userName.lastName}
                onChange={(event) => handleNameChange(event, "lastName")}
                size='small'
                InputProps={{
                  style: {
                    borderRadius: 0,
                  },
                }}
              />
            </Grid>    
            {checkFlag('limitedUserAccess') && (
            <>       
              <Grid item xs={3} display='flex' alignItems='center'>
                <Typography>Account Access</Typography>  
              </Grid>  
              <Grid item xs={9}>
                <SelectBankAccountTag 
                  groups={groups} 
                  customTags={customTags}
                  loading={loading}
                  includeUncategorized={false}
                  multiSelect={true}
                  onChange={handleAccessChange}
                  placeholder='Select a tag to limit access. Otherwise the user will have full access.'
                  currentTagIds={userAccountTags}
                />
              </Grid>
            </>
            )}
          </Grid>
          <TableContainer sx={{ marginTop: 3 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography>Permission</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography align="center">Amount</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography align="right">Unlimited</Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              {userPermissions.map((permission, idx, arr) => {
                const bottomBorder = idx + 1 == arr.length ? "none" : null;
                const isUnlimited = permission.value == "-1.00";
                return (
                  <TableRow sx={{ height: "100px" }} key={permission.fieldName}>
                    <TableCell sx={{ borderBottom: bottomBorder }} colSpan={3}>
                      <Grid container spacing={2}>
                        <Grid item xs={5}>
                          <Typography sx={{ fontWeight: "bold" }}>
                            {permission.displayName}
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {isUnlimited ? (
                            <Typography
                              color="secondary"
                              sx={{ fontStyle: "italic" }}
                            >
                              Unlimited
                            </Typography>
                          ) : (
                            <TextField
                              defaultValue={permission.value}
                              type="number"
                              sx={{ width: '80%' }}
                              size='small'
                              InputProps={{
                                style: {
                                  borderRadius: 0,
                                },
                                inputProps: { min: 0 },
                                startAdornment: (
                                  <InputAdornment position="start">$</InputAdornment>
                                ),
                              }}
                              onChange={(event) =>
                                handleInput(event, permission.fieldName)
                              }
                            />
                          )}
                        </Grid>

                        <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                          <FormControlLabel
                            control={
                              <Switch
                                defaultChecked={isUnlimited}
                                onChange={(event) =>
                                  toggleUnlimited(event, permission.fieldName)
                                }
                              />
                            }
                          />
                        </Grid>
                      </Grid>
                    </TableCell>
                  </TableRow>

                );
              })}
            </Table>
          </TableContainer>
        </Box>
      }
      actions={
        <StyledButton fontSize={14} label="Submit" onClick={handleSubmit} />
      }
    />
  ) : (
    <></>
  );
};

export default TeamPermissionModal;
